
import Vue  from 'vue'
import axios from "axios";
import { DentalToothNotation } from 'types/DentalToothNotation'
import { WaitlistTreatment , WaitlistSurfaceTreatment, DentalLog, DentalToothMarkings,  
    DentalCondition, DentalToothNote, KeyValuePairOfIntegerAndString, PermissionType, DentalConditionType } from '../../../types/Sapphire_dto'
import ToothImage from "./ToothImage.vue"
// import ContextMenu, { ContextMenuRef } from "../shared/ContextMenu.vue";

import * as VueMenu from '@hscmap/vue-menu'
import ContextMenu, { ContextMenuRef } from '../shared/ContextMenu.vue';
Vue.use(VueMenu)

export default Vue.extend({
    components: {  ToothImage, ContextMenu },
    name: "dental-image-editor-vue-component",
    props: {
        sessionID: Number,
        patientId: String,
        dentalItems: Array as () => Array<DentalLog>,
        toothMarkings:  Array as () => Array<DentalToothMarkings>,
        missingTeethList:  Array as () => Array<KeyValuePairOfIntegerAndString>,
        selectedTeeth: Array as () => Array<KeyValuePairOfIntegerAndString>,
        toothNotes: Array as () => Array<DentalToothNote>,
        dentalConditionList: Array as () => Array<DentalCondition>,
        toothNotationList: Array as () => Array<DentalToothNotation>,
        selectedFilterID: Number,
        AllCount: Number,
        PreExistingCount: Number,
        OnWaitlistCount: Number,
        CompletedCount: Number,
        ConditionCount: Number,
        inactiveCount: Number,
        permissions: Array as () => Array<PermissionType>,
        isSA: Boolean
    },
    computed: {
        toothContextMenu(): ContextMenuRef {
            return this.$refs.dentalToothMenu as ContextMenuRef;
        },
        // surfaceTypes(): string[] {
        //     const arrayUniqueByKey = [...new Map(this.dentalTopofTeethTreatmentList.map(item =>
        //       [item.SurfaceTypeID, item.SurfaceType])).values()];
        //     console.log(arrayUniqueByKey);
        //     return ['blah'];
        // }
        surfaceTypes(): WaitlistSurfaceTreatment[] {
            const ids = [...new Set(this.dentalSurfaceTreatmentList.map(x => x.SurfaceTypeID))];
            const distinct = ids.map(id => this.dentalSurfaceTreatmentList.find(x => x.SurfaceTypeID === id));

            return distinct;
        },
        selectedTeethCount(): Number {
            return this.selectedTeeth.length;
        }
    },
    watch: {
        selectedFilterID: function (newVal, oldVal) {
          if (newVal != oldVal) {
            this.thisStatusFilterID = newVal;
          }
        },
        thisStatusFilterID: function (newVal, oldVal) {
          if (newVal != oldVal) {
            this.$emit("filterStatus", newVal);
          }
        },
        selectedTeethCount: function (newVal, oldVal) {
            if (newVal != oldVal) {
                this.toothContextMenu.getMenuItems(this.selectedTeeth.length.toString());
            }
        }
    },
    data() {
        return {
            PermissionType,
            teeth: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
            21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32],
            thisStatusFilterID: 0,
            logFilterList: [],
            allConditionTypes: [] as DentalConditionType[],
            ConditionsWithSymbols: [] as DentalCondition[],
            dentalTreatmentList: [] as WaitlistTreatment[],
            dentalSurfaceTreatmentList: [] as WaitlistSurfaceTreatment[],
            dentalSurfaceConditionList: [] as WaitlistSurfaceTreatment[],
            waitlistSurfaces: [] as KeyValuePairOfIntegerAndString[],
            cariesList: [6,12,13,14],
            RootConList: [17,18,26],
            SurfaceConList: [5,16,22,25,27],
        };
    },
    mounted() {
        this.initComponent();
    },
    methods: {
        async initComponent() {
            await this.getAllConditionList();
            await this.getAllCommonTreatmentsList();
            await this.getAllSurfaceTreatmentsList();
            this.allConditionTypes.forEach(this.GetConditionsWithSymbols);
            await this.getWaitlistSurfaces();
            await this.toothContextMenu.getMenuItems(this.selectedTeeth.length.toString());
        },
        async getWaitlistSurfaces() {
            await axios
                .post(
                "../../../Common/Services/EhrTaskService.svc/GetWaitlistSurfaces"
                )
                .then((response) => {
                this.waitlistSurfaces.length = 0;
                this.waitlistSurfaces = JSON.parse(response.data.d);
            });
        },
        AddCommonTreatment(parameterString: string) {
            let parameters = parameterString.split('|');
            this.$emit("addCommonTreatment", parameters[0], parameters[1], parameters[2]);
        },
        GetConditionsWithSymbols(item) {
            if (item.Symbol != '') {
                this.ConditionsWithSymbols.push(item);
            }
        },
        async getAllConditionList() {
            await axios
                .post(
                "../../../Common/Services/EhrTaskService.svc/GetDentalConditionTypes"
                )
                .then((response) => {
                this.allConditionTypes = [];
                this.allConditionTypes = JSON.parse(response.data.d);
                });
        },
        async getAllCommonTreatmentsList() {
            const response = await axios.post(
                "../../../Common/Services/EhrTaskService.svc/GetDentalTreatmentList"
                )
            let tempList: WaitlistTreatment[] = [];
            tempList = JSON.parse(response.data.d);
            this.dentalTreatmentList = tempList.filter(wt => wt.CommonFlag);
        },
        async getAllSurfaceTreatmentsList() {
            const response = await axios.post(
                "../../../Common/Services/EhrTaskService.svc/GetDentalSurfaceTreatmentList"
                )
            let tempList: WaitlistSurfaceTreatment[] = [];
            tempList = JSON.parse(response.data.d);
            this.dentalSurfaceTreatmentList = tempList;
        },
        async getAllSurfaceConditionsList() {
            const response = await axios.post(
                "../../../Common/Services/EhrTaskService.svc/GetDentalSurfaceConditionList"
                )
            let tempList: WaitlistSurfaceTreatment[] = [];
            tempList = JSON.parse(response.data.d);
            this.dentalSurfaceConditionList = tempList;
        },
        AddCondition(parameterString: string) {
            let parameters = parameterString.split('|');
            this.$emit("addCommonCondition", parameters[0], parameters[1]);
        },
        ViewConditions() {
            this.$emit("viewConditions");
        },
        ViewNotes() {
            this.$emit("viewNotes");
        },
        AddQuickNote() {
            this.$emit("addNote");
        },
        AddTreatment() {
            this.$emit("addTreatmentOnToothClick");
        },
        ToothSelected(toothID: number) {
            if (toothID > 0) {
                this.$emit("toothSelected", toothID);
            }
        },
        SelectRemainingTeeth(parameterString: string) {
            let parameters = parameterString.split('|');
            this.$emit("selectRemainingTeeth", parseInt(parameters[0]), parseInt(parameters[1]));
        },
        clearSelectedTeeth() {
            this.$emit("clearSelectedTeeth");
        },
        isInList(element, list) {
            if(list.includes(element))
            return (element)
        },
        // handleToothClick: function(evt: MouseEvent, toothID: number) {
        //     //We should toggle the menu when the user clicks the tooth.
        //     this.currentToothID=toothID;
        //     evt.preventDefault();

        //     // console.log(`pageX: ${evt.pageX}, pageY: ${evt.pageY}`);
        //     const scrollingElement = document.scrollingElement || document.documentElement;
        //     let ctxLeft = evt.pageX;
        //     let ctxTop = evt.pageY - scrollingElement.scrollTop;
        //     this.toothContextMenu.open('toothMenu', ctxLeft, ctxTop);
        // },
    },
});
